import React from 'react';
import Alert from '@mui/material/Alert';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/slices/feedback';

const useStyles = makeStyles({
    alert: {
        position: "fixed",
        zIndex: 10000,
        width: "calc(100% - 32px)"
    },
    hidden: {
        display: "none"
    }
})

export default ({}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { alert } = useSelector(state => state.feedback);
    const { on, message } = alert;
    const onClose = () => {
        dispatch(setAlert({on: false, message: ""}))
    }
    return (
        <>
        {!on ? null : 
            <Alert 
                className={classes.alert + " " + classes.hidden} 
                severity="error"
                onClose={onClose}
            >
                {message}
            </Alert>
        }
        </>

    )
}